<template>
  <div
    class="page-overlay"
    :class="{
      'page-overlay--no-padding-mobile': noPaddingMobile,
    }"
    @mousedown="handleClick"
  >
    <slot />
  </div>
</template>

<script>
export default defineComponent({
  inject: ['$bus'],
  props: {
    noPaddingMobile: {
      type: Boolean,
      default: true,
    },
    keepBodyScrollPosition: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['click'],
  data: () => ({
    scrollbarWidth: 0,
  }),
  created() {
    if (import.meta.client) {
      this.scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

      // Prevent body from expanding in width after y-scrollbar is hidden
      document.body.style.width = `calc(100% - ${this.scrollbarWidth}px`;
      document.body.classList.add('no-scrolling');
      if (!this.keepBodyScrollPosition) {
        document.body.classList.add('fixed');
      }
    }
  },
  unmounted() {
    if (import.meta.client) {
      document.body.classList.remove('no-scrolling', 'fixed');
      document.body.style.width = '100%';
    }
  },
  methods: {
    handleClick(event) {
      // Prevent click handler when click happens on right scroll bar (this.scrollbarWidth)
      if (event.target !== this.$el || window.innerWidth - event.clientX < this.scrollbarWidth) {
        return;
      }

      this.$emit('click', event);
    },
  },
});
</script>

<style lang="scss" scoped>
.page-overlay {
  display: flex;
  flex-direction: column;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background-color: rgba(palette(black), 0.8);
  padding: $pad;
  overflow-y: auto;

  &.page-overlay--no-padding-mobile {
    @include bp(m, max) {
      padding: 0;
    }
  }
}
</style>
